module.exports = __webpack_public_path__ + "img/pr-1.37ef76b2.png";